const COMMON_DOT_COM_EMAIL_DOMAINS = new Set([
  '126',
  '163',
  'foxmail',
  'gmail',
  'hotmail',
  'icloud',
  'live',
  'outlook',
  'protonmail',
  'qq',
  'sina',
  'yahoo'
]);

export function getCommonEmailTypoSuggestion(email) {
  const atIndex = email.lastIndexOf('@');
  if (atIndex === -1) {
    return null;
  }

  const localPart = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1).toLowerCase();
  const [domainName, tld] = domain.split('.');

  if (tld !== 'cm' || !COMMON_DOT_COM_EMAIL_DOMAINS.has(domainName)) {
    return null;
  }

  return `${localPart}@${domainName}.com`;
}
